/**
 * Los repasos hablados suman a los minutos del día de «Tu rutina» (Emmanuel, 22/10, card #603):
 * el Repaso del día (`'day'`) y el de la Bodega de la nave (`'words'`). La Audioteca no suma.
 *
 * Se cuenta el tiempo ACTIVO, con la regla de los minutos de charla (`session-activity.ts` del
 * backend): la suma de los huecos entre lo que pasa en el repaso, cada uno acotado a
 * {@link REVIEW_GAP_CAP_MS}. Un repaso abierto y olvidado no suma más que eso.
 */
import { apiFetch } from '../../../lib/apiClient.js';

export type ReviewTimeSource = 'day' | 'words';

/** El mismo tope por tramo que los minutos de charla (`TURN_GAP_CAP_SECONDS`). */
export const REVIEW_GAP_CAP_MS = 45_000;

export interface ReviewClock {
  /** Pasó algo en el repaso (dijo, siguió, cerró…): suma el hueco desde lo anterior, acotado. */
  tick: () => void;
  /** Los segundos activos hasta el último `tick`. */
  seconds: () => number;
}

export function createReviewClock(now: () => number = Date.now): ReviewClock {
  let last = now();
  let ms = 0;
  return {
    tick() {
      const t = now();
      ms += Math.min(Math.max(t - last, 0), REVIEW_GAP_CAP_MS);
      last = t;
    },
    seconds: () => Math.round(ms / 1000),
  };
}

/** Anota el repaso cerrado. Un no-2xx TIRA (quien llama lo avisa en la consola). */
export async function postReviewTime(source: ReviewTimeSource, seconds: number): Promise<void> {
  const res = await apiFetch('/api/modules/english/review/time', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ source, seconds }),
  });
  if (!res.ok) throw new Error(`review/time: HTTP ${res.status}`);
}
